import { IssueReportTypeItem } from './IssueReportTypeItem'

export const DailyInspectionInspection = new IssueReportTypeItem({
  id: '087A8C90-0E6B-49A2-8A22-AE1E2C76FB76',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
})

export const DailyInspectionControlPoint = new IssueReportTypeItem({
  id: '362E7AE2-2228-46AB-8D4A-A0D56089D10E',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
})

export const DailyInspectionPunchList = new IssueReportTypeItem({
  id: '90D8FEF3-9A75-4751-948F-C83267D51C81',
  classType: 'DailyInspectionPunchList',
  label: 'punchListId',
  type: 'Punch List',
})

export const ConcreteTest = new IssueReportTypeItem({
  id: '42B05837-080F-46CF-8853-6399460C6F0E',
  classType: 'ConcreteTest',
  label: 'fieldNumber',
  type: 'Concrete Test',
})

export const ConcreteTestSet = new IssueReportTypeItem({
  id: '01BD64E9-026A-49C1-9DBB-906DD00AC330',
  classType: 'ConcreteTestSet',
  label: 'testSetId',
  type: 'Concrete Test Set',
})

export const DensityLot = new IssueReportTypeItem({
  id: '2C6755AC-A2BB-46AF-BEB1-417178935EEF',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
})

export const AsphaltLot = new IssueReportTypeItem({
  id: 'B88B60F5-519F-4A44-A3BA-6561E661B76F',
  classType: 'AsphaltLot',
  label: 'asphaltLotId',
  type: 'Asphalt Lot',
})
